import React from 'react';
import { Outlet, useNavigation } from 'react-router-dom';

import { Spinner } from '@myhealth-raccoon/components';

export function LoadingScreen({ children }: React.PropsWithChildren) {
    const navigation = useNavigation();

    if (navigation.state === 'idle') {
        return (
            <>
                <Outlet />
                {children}
            </>
        );
    }
    return <Spinner className="absolute inset-0 flex items-center justify-center" />;
}
